export const preheatBurying = {
  cid: 'c_waimai_c_overseas_aatucy3n', // 组件cid
  ggMV: 'b_sailor_c_8p6szc6d_mv', // 未登陆-去逛逛曝光
  ggMC: 'b_sailor_c_8p6szc6d_mc', // 未登陆-去逛逛点击
  ggMVLogined: 'b_sailor_c_7cjcwd7y_mv', // 已登陆-去逛逛曝光
  ggMCLogined: 'b_sailor_c_7cjcwd7y_mc', // 已登陆-去逛逛点击
  loginMV: 'b_sailor_c_elnr3sy1_mv', // 未登陆-登陆按钮曝光
  loginMC: 'b_sailor_c_elnr3sy1_mc', // 未登陆-登陆按钮点击
  preheatLoginMV: 'b_sailor_c_b3ecj2bo_mv', // 已登陆-登陆按钮曝光
  preheatLoginMC: 'b_sailor_c_b3ecj2bo_mc', // 已登陆-登陆按钮曝光
  nuclearButtonMV: 'b_sailor_c_p65nw7zi_mv', //核按钮页面曝光
};

// 店铺收藏页埋点相关
export const SHOP_FAVORITES_MV_BID = 'b_sailor_c_zhbm4qcw_mv';
export const SHOP_FAVORITES_MC_BID = 'b_sailor_c_zhbm4qcw_mc';

/**
 * 更新页面cid
 * @param mCid logData中的cid
 */
export function updateCid(mCid) {
  if (mCid) {
    preheatBurying.cid = mCid;
  }
}

export enum PAGE_CODE{
  SHOP_FAVORITES = '1', // 收藏页
}
export const SHOP_FAVORITES_CID = 'c_waimai_c_overseas_uvyhshpd';

export const ggMV = (logined: boolean, params = {}) => {
  const Statistics = Mach.requireModule('Statistics');
  const bid = logined ? preheatBurying.ggMVLogined : preheatBurying.ggMV;
  Statistics.view(preheatBurying.cid, bid, params);
};

export const ggMC = (logined: boolean, params = {}) => {
  const Statistics = Mach.requireModule('Statistics');
  const cid = preheatBurying.cid;
  const bid = logined ? preheatBurying.ggMCLogined : preheatBurying.ggMC;
  Statistics.click(cid, bid, params);
};

export const loginMV = (params = {}) => {
  const Statistics = Mach.requireModule('Statistics');
  Statistics.view(preheatBurying.cid, preheatBurying.loginMV, params);
};

export const nuclearButtonMV = (params = {}) => {
  const Statistics = Mach.requireModule('Statistics');
  Statistics.view(preheatBurying.cid, preheatBurying.nuclearButtonMV, params);
};

export const loginMC = (params = {}) => {
  const Statistics = Mach.requireModule('Statistics');
  const cid = preheatBurying.cid;
  Statistics.click(cid, preheatBurying.loginMC, params);
};

export const preheatPV = () => {
  const Statistics = Mach.requireModule('Statistics');
  Statistics.pv(preheatBurying.cid, {});
};

export const preheatLoginMC = () => {
  const Statistics = Mach.requireModule('Statistics');
  Statistics.click(preheatBurying.cid, preheatBurying.preheatLoginMC);
};

export const preheatLoginMV = () => {
  const Statistics = Mach.requireModule('Statistics');
  Statistics.view(preheatBurying.cid, preheatBurying.preheatLoginMV);
};

export const PreheatBtnMV = (bid) => {
  const Statistics = Mach.requireModule('Statistics');
  Statistics.view(preheatBurying.cid, bid);
};

export const PreheatBtnMC = (bid) => {
  const Statistics = Mach.requireModule('Statistics');
  Statistics.click(preheatBurying.cid, bid);
};
